module.exports = __webpack_public_path__ + "img/11_financial-wellness.49b676ab.png";